import hamburgerSvg from '../../../assets/svg/burger.svg';

export default Object.freeze({
	hamburger: hamburgerSvg,
});